import { jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from "react";
import { Button as Button$1 } from "@mui/material";
import { buttonStyles } from "./Button.styles.js";
const Button = forwardRef(({
  variant = "text",
  color = "primary",
  ...props
}, ref) => {
  if (variant !== "contained" && color !== "primary") {
    console.warn(`INVALID PROP COMBINATION - Ascend Button colors other than 'primary' can only be used with the 'contained' variant`);
  }
  return /* @__PURE__ */ jsx(Button$1, { css: buttonStyles, variant, color, disableElevation: true, ref, ...props });
});
export {
  Button
};
//# sourceMappingURL=Button.js.map
